/* eslint-disable import/no-anonymous-default-export */

import LedgerReportsActionTypes from './LedgerReports.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	getLedgerReportsListResponse: null,
	getLedgerReportsListArr: [],
	getLedgerReportsListStatus: null,

	getAccountHeadResponse: null,
	getAccountHeadArr: [],
	getAccountHeadStatus: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case LedgerReportsActionTypes.GET_LEDGER_REPORTS_LIST_SUCCESS:
			return {
				...state,
				getLedgerReportsListResponse: action.payload,
				getLedgerReportsListArr: docodeHexResponse(action.payload, 'GetLedgerReportsKey'),
				getLedgerReportsListStatus: 'Success',
			};

		case LedgerReportsActionTypes.GET_LEDGER_REPORTS_LIST_FAILURE:
			return { ...state, getLedgerReportsListStatus: action.payload };

		case LedgerReportsActionTypes.GET_LEDGER_REPORTS_LIST_RESPONSE_CHANGED:
			return { ...state, getLedgerReportsListResponse: null };

		case LedgerReportsActionTypes.GET_ACCOUNT_HEAD_SUCCESS:
			return {
				...state,
				getAccountHeadResponse: action.payload,
				getAccountHeadArr: docodeHexResponse(action.payload, 'GetAccountHeadKey'),
				getAccountHeadStatus: 'Success',
			};

		case LedgerReportsActionTypes.GET_ACCOUNT_HEAD_FAILURE:
			return { ...state, getAccountHeadStatus: action.payload };

		case LedgerReportsActionTypes.GET_ACCOUNT_HEAD_RESPONSE_CHANGED:
			return { ...state, getAccountHeadResponse: null };

		default:
			return state;
	}
};
